/* eslint-disable react/prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unescaped-entities */
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import PropTypes from 'prop-types';
import { formatDate } from 'utils/formatDate';
import BudgetSearchInput from 'components/BudgetSearchInput';
import CornerSpinner from 'components/CornerSpinner';
import { formatCurrency } from 'utils/helper';
import { Dropdown } from 'react-bootstrap';
import {
  NewFolder,
  ShowMore,
  NewBudget,
  FolderIcon,
  CrossIcon,
  OpenInNew,
  Download,
  Edit,
  Delete,
  MoveIcon,
  GreaterArrow,
  Icon,
  DuplicateIcon,
} from 'utils/icons';
import BudgetIcon from 'assets/images/Budget.png';
import { useHomeScreenContext } from 'layouts/HomeScreenLayout/contexts/HomeScreenContext';
import MoveBudgets from '../../components/MoveBudgets';
import { toast } from 'react-toastify';
import {
  useTable,
  useSortBy,
  useRowSelect,
  useGlobalFilter,
} from 'react-table';
import DeleteMultiBudgets from 'components/DeleteMultiBudgets';
import { useBudgetQueries, useTabsQueries } from 'utils/api/queries';
import { useBudgetMutation } from 'utils/api/mutations';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles.scss';
import AddFolder from 'components/AddFolder';
import EditFolder from 'components/EditFolder';
import CreateBudgetInsideFolder from 'components/CreateBudgetInsideFolder';
import EditBudgetInsideFolder from 'components/EditBudgetInsideFolder';
import DeleteFolder from 'components/DeleteFolder';

const DRAG_ROWS_MIME_TYPE = 'application/vnd.cinebudget.my-budgets.rows';

const COLLABORATOR_COLORS = [
  '#2f80ed',
  '#f2994a',
  '#27ae60',
  '#9b51e0',
  '#eb5757',
  '#00a6a6',
  '#f2c94c',
  '#4d5abc',
];

const getBudgetRowKey = row => `${row?.type || ''}:${row?.id || ''}`;

const getCollaboratorSeed = collaborator =>
  `${collaborator?.id || ''}:${collaborator?.email || ''}:${
    collaborator?.name || ''
  }`;

const getStableCollaboratorColor = collaborator => {
  const seed = getCollaboratorSeed(collaborator);
  let hash = 0;

  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash << 5) - hash + seed.charCodeAt(i);
    hash |= 0;
  }

  return COLLABORATOR_COLORS[Math.abs(hash) % COLLABORATOR_COLORS.length];
};

const getCollaboratorInitials = collaborator =>
  collaborator?.name
    ?.split(' ')
    ?.filter(Boolean)
    ?.map(word => word.charAt(0))
    .join('') || '?';

const mapBudgetDetailsToRows = budgetData =>
  (budgetData || []).map(budget => ({
    id: budget?.id,
    parent_id:
      budget?.type === 'Folder' ? budget?.parent_folder : budget?.folder,
    type: budget?.type,
    full_name: budget?.name,
    my_permission: budget?.my_permission || null,
    owner: budget?.created_by_name,
    created_date: budget?.created_on,
    last_updated: budget?.updated_on,
    total: budget?.type === 'Folder' ? '' : budget?.total_cost,
    created_by_email: budget?.created_by_email,
    last_edited_by_this_collaborator: budget?.last_edited_by_this_collaborator,
    template_type: budget?.template_type,
    created_by_name: budget?.created_by_name || '',
    created_by_profile_image: budget?.created_by_profile_image,
    last_edited_by: budget?.last_edited_by || undefined,
    createdBy:
      budget?.type === 'Budget' ? budget?.created_by_profile_image : '',
    collaborators:
      (budget?.type !== 'Folder' &&
        budget?.collaborators?.map(collaborator => ({
          id: collaborator?.id,
          name: collaborator?.collaborator_name,
          email: collaborator?.collaborator_user_email,
          profileImage: collaborator?.collaborator_profile_image || '',
          lastEdited: collaborator?.last_edited_by_this_collaborator,
        }))) ||
      [],
  }));

const BudgetDetails = () => {
  const { createTabsMutation } = useHomeScreenContext();
  const [searchTxt, setSearchTxt] = useState('');
  const [showMovePopup, setShowMovePopup] = useState(false);
  const [shouldCallApi, setShouldCallApi] = useState(true);
  const [advSearch, setAdvsearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [parentId, setparentId] = useState(null);
  const [parentNames, setparentNames] = useState([]);
  const [showAddFolder, setShowAddFolder] = useState(false);
  const [showEditFolder, setShowEditFolder] = useState(false);
  const [folderName, setFolderName] = useState('');
  const [budgetName, setbudgetName] = useState('');
  const [folderId, setFolderId] = useState('');
  const [budgetId, setbudgetId] = useState(null);
  const [showBudgetFolder, setShowBudgetFolder] = useState(false);
  const [showEditBudgetFolder, setShowEditBudgetFolder] = useState(false);
  const [BudgetTypeData, setBudgetType] = useState('');

  const closeFolder = () => {
    setShowAddFolder(false);
    setShowEditFolder(false);
    setShowBudgetFolder(false);
    setShowEditBudgetFolder(false);
  };

  const handleMovePopupClose = () => {
    setShowMovePopup(false);
    setSelectedRows([]);
    setparentNames([]);
    setparentId(null);
    setSearchQuery('');
    setAdvsearch(false);
    refetch();
  };

  const duplicateBudgetMutation =
    useBudgetMutation.useDuplicateBudgetMutation();
  const duplicateBudget = duplicateBudgetMutation.mutateAsync;

  const handleDuplicateSelected = async () => {
    if (!selectedRows?.length) return;
    toast.loading(
      `Please wait while we are duplicating budget${
        selectedRows.length > 1 ? 's' : ''
      } ...`
    );
    try {
      await Promise.all(
        selectedRows.map(row =>
          duplicateBudget({
            budget_id: row?.id,
            withValues: true,
          })
        )
      );
      toast.dismiss();
      toast.success(
        `Budget${selectedRows.length > 1 ? 's' : ''} duplicated successfully`
      );
    } catch (error) {
      console.error('Error duplicating selected budgets:', error);
      toast.dismiss();
      toast.error('Something went wrong while duplicating');
    } finally {
      setSelectedRows([]);
      refetch();
    }
  };

  const {
    data: budget_details,
    isLoading,
    refetch,
  } = useBudgetQueries.useBudgetDetailsDataQuery({
    payload: {
      adv_search: advSearch,
      search: searchQuery,
      parent_folder: parentId,
    },
    enabled: shouldCallApi,
  });
  const budgetData = budget_details?.data;
  const products = useMemo(
    () => mapBudgetDetailsToRows(budgetData),
    [budgetData]
  );
  const loading = isLoading && !budgetData;

  //calling open tabsblist API
  const { data: tabsDetails } = useTabsQueries.useOpenTabsQuery({
    enabled: true,
  });
  const tabsData = tabsDetails?.data;

  const {
    showShareBudgetModal,
    setSelectedDeldata,
    setFolderSelectedDeldata,
    showDeleteMultiBudgets,
    showDeleteFolder,
    makeAciveTabMutation,
    selectTab,
    setOpenTabsList,
    hasBudgetEditAccessInList,
    moveBudgetFolderMutation,
    refetchFolders,
  } = useHomeScreenContext();
  const createTabs = createTabsMutation.mutateAsync;
  const makeActiveTab = makeAciveTabMutation.mutateAsync;
  const [selectedRows, setSelectedRows] = useState([]);
  const [draggedRows, setDraggedRows] = useState([]);
  const [dragOverFolderId, setDragOverFolderId] = useState(null);
  const productsRef = useRef(products);
  const searchBarRef = useRef();

  const handleCreateTabs = useCallback(
    async selRowsData => {
      const payload = [];
      for (let i = 0; i < selRowsData?.length; i++) {
        payload?.push({
          budget: selRowsData[i]?.id,
        });
      }
      try {
        const response = await createTabs(payload);
        const newTabs = response?.data;
        await makeActiveTab(newTabs[0]?.id);
        setOpenTabsList([...(tabsData || []), ...(newTabs || [])]);

        window.location.href = '/home';
      } catch (error) {
        console.error('Error creating budget tabs:', error);
      }
    },
    [createTabs, makeActiveTab, setOpenTabsList, tabsData]
  );

  const handleDuplicateRow = useCallback(
    async budgetRow => {
      if (!budgetRow?.id) return;
      toast.loading(
        `Please wait while we are duplicating budget ${budgetRow?.full_name} ...`
      );
      try {
        await duplicateBudget({
          budget_id: budgetRow.id,
          withValues: true,
        });
        toast.dismiss();
        toast.success('Budget duplicated successfully');
      } catch (error) {
        console.error('Error duplicating budget:', error);
        toast.dismiss();
        toast.error('Something went wrong while duplicating');
      } finally {
        refetch();
      }
    },
    [duplicateBudget, refetch]
  );

  const handleCheckboxChange = e => {
    setAdvsearch(e?.target?.checked);
    setparentNames([]);
    setparentId(null);
  };

  const handleSearchChange = event => {
    const value = event?.target?.value;
    setSearchTxt(value);
  };

  const handleClearSearch = () => {
    setSearchTxt('');
    setSearchQuery('');
  };

  const handleCollaboratorCls = (collaborator, index, row) => {
    if (row?.original?.type === 'Folder') {
      return;
    }
    if (index === 0) {
      if (collaborator?.profileImage) {
        return 'first-collaborator-img';
      } else {
        return 'first-collaborator';
      }
    } else {
      return 'user-pic-wrapepr';
    }
  };
  const handleKeyPress = event => {
    if (event.key === 'Enter') {
      setSearchQuery(searchTxt);
    }
    // if (searchTxt !== '') {
    setparentNames([]);
    setparentId(null);
    // }
  };

  const data = useMemo(() => products, [products]);

  const handleSelectRow = (event, row) => {
    const isChecked = event?.target?.checked;
    // if (selectedRows?.length <= 3) {
    if (isChecked) {
      setSelectedRows(prevSelected => [...prevSelected, row.original]);
    } else {
      setSelectedRows(prevSelected =>
        prevSelected.filter(
          selectedRow =>
            !(
              selectedRow.id === row.original.id &&
              selectedRow.type === row.original.type
            )
        )
      );
    }
    // }
    if (!isChecked) {
      setSelectedRows(prevSelected =>
        prevSelected.filter(
          selectedRow =>
            !(
              selectedRow.id === row.original.id &&
              selectedRow.type === row.original.type
            )
        )
      );
    }
  };

  const getDraggedRowsFromEvent = event => {
    try {
      const rawValue = event.dataTransfer.getData(DRAG_ROWS_MIME_TYPE);
      return rawValue ? JSON.parse(rawValue) : [];
    } catch (error) {
      return [];
    }
  };

  const canDropRowsIntoFolder = (rowsToDrop, targetRow) => {
    if (targetRow?.type !== 'Folder' || !rowsToDrop?.length) {
      return false;
    }

    return rowsToDrop.some(
      row =>
        !(row?.type === 'Folder' && row?.id === targetRow.id) &&
        row?.parent_id !== targetRow.id
    );
  };

  const clearDragState = () => {
    setDraggedRows([]);
    setDragOverFolderId(null);
  };

  const handleRowDragStart = (event, rowItem) => {
    const rowKey = getBudgetRowKey(rowItem);
    const selectedIncludesDraggedRow = selectedRows.some(
      selectedRow => getBudgetRowKey(selectedRow) === rowKey
    );
    const rowsToDrag = selectedIncludesDraggedRow ? selectedRows : [rowItem];

    if (!rowsToDrag?.length) {
      return;
    }

    if (!selectedIncludesDraggedRow) {
      setSelectedRows([rowItem]);
    }

    setDraggedRows(rowsToDrag);
    event.dataTransfer.effectAllowed = 'move';
    event.dataTransfer.setData(
      DRAG_ROWS_MIME_TYPE,
      JSON.stringify(
        rowsToDrag.map(row => ({
          id: row.id,
          type: row.type,
          parent_id: row.parent_id,
          full_name: row.full_name,
        }))
      )
    );
    event.dataTransfer.setData(
      'text/plain',
      rowsToDrag.map(row => row.full_name).join(', ')
    );
  };

  const handleRowDragOver = (event, targetRow) => {
    const rowsToDrop =
      draggedRows?.length > 0 ? draggedRows : getDraggedRowsFromEvent(event);

    if (!canDropRowsIntoFolder(rowsToDrop, targetRow)) {
      return;
    }

    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
    setDragOverFolderId(targetRow.id);
  };

  const handleRowDragLeave = (event, targetRow) => {
    if (
      dragOverFolderId === targetRow?.id &&
      !event.currentTarget.contains(event.relatedTarget)
    ) {
      setDragOverFolderId(null);
    }
  };

  const handleRowDrop = async (event, targetRow) => {
    event.preventDefault();
    event.stopPropagation();

    const rowsToDrop =
      draggedRows?.length > 0 ? draggedRows : getDraggedRowsFromEvent(event);
    const rowsToMove = rowsToDrop.filter(
      row =>
        !(row?.type === 'Folder' && row?.id === targetRow?.id) &&
        row?.parent_id !== targetRow?.id
    );

    if (!canDropRowsIntoFolder(rowsToMove, targetRow)) {
      clearDragState();
      return;
    }

    const budgetIds = rowsToMove
      .filter(row => row?.type === 'Budget')
      .map(row => row.id);
    const folderIds = rowsToMove
      .filter(row => row?.type === 'Folder')
      .map(row => row.id);

    try {
      await moveBudgetFolderMutation.mutateAsync({
        budget_ids: budgetIds,
        folder_ids: folderIds,
        folder: targetRow.id,
      });
      setSelectedRows([]);
      await refetch();
      refetchFolders?.();
      toast.success(
        `${rowsToMove.length === 1 ? 'Item' : 'Items'} moved to ${
          targetRow.full_name
        }`
      );
    } catch (error) {
      console.error('Error moving selected budgets or folders:', error);
      toast.error(
        error?.response?.data?.detail || 'Unable to move selected items.'
      );
    } finally {
      clearDragState();
    }
  };

  useEffect(() => {
    // Update the ref value whenever the products state changes
    productsRef.current = products;
  }, [products]);

  useEffect(() => {
    // Reset selectedRows when data changes
    setSelectedRows([]);
  }, [data]);

  useEffect(() => {
    // Your logic for handling selectedRows changes
  }, [selectedRows]);

  const handleShare = useCallback(
    (id, dataTemp) => {
      selectTab(id, dataTemp);
      showShareBudgetModal();
    },
    [selectTab, showShareBudgetModal]
  );
  const columns = useMemo(
    () => [
      {
        Header: (
          <>
            <span
              className="header-txt"
              style={{ marginRight: '5px', marginLeft: '50px' }}
            >
              Budget Name
            </span>
            {/* <Search /> */}
          </>
        ),
        accessor: 'full_name',
        sticky: 'left',
        Cell: ({ row }) => (
          <div
            className={
              row?.original?.type === 'Folder'
                ? 'uname-cell cursorpointer'
                : 'uname-cell cursorpointer'
            }
          >
            <input
              type="checkbox"
              checked={selectedRows.some(
                selectedRow =>
                  selectedRow.id === row.original.id &&
                  selectedRow.type === row.original.type
              )}
              style={{
                cursor: 'pointer',
                width: '16px',
                height: '16px',
                margin: '0px 10px 0px 5px',
              }}
              onChange={event => {
                handleSelectRow(event, row);
              }}
              className="custom-checkbox"
            />
            {row.original.type === 'Folder' ? (
              <FolderIcon />
            ) : (
              <img
                src={BudgetIcon}
                alt="Budget"
                onClick={() => {
                  selectTab(row?.original?.id, row?.original);
                  handleCreateTabs([row?.original]);
                }}
              />
            )}
            &nbsp;
            <span
              className={
                row?.original?.type === 'Folder'
                  ? 'header-cell cursorpointer'
                  : 'header-cell cursorpointer'
              }
              style={{ marginRight: '10px' }}
              onClick={() => {
                if (row?.original?.type === 'Folder') {
                  // setparentNames(prevParents => [
                  //   ...prevParents,
                  //   {
                  //     name: row?.original?.full_name,
                  //     parent_id: row?.original?.id,
                  //     id: row?.original?.parent_id,
                  //   },
                  // ]);
                  setparentNames(prevParents => {
                    // Check if the id already exists in the array
                    const idExists = prevParents.some(
                      parent => parent.id === row?.original?.parent_id
                    );

                    if (!idExists) {
                      // If the id doesn't exist, append the new object
                      return [
                        ...prevParents,
                        {
                          name: row?.original?.full_name,
                          parent_id: row?.original?.id,
                          id: row?.original?.parent_id,
                        },
                      ];
                    } else {
                      // If the id already exists, you can choose to update the existing object or ignore the new one
                      // For example, you might want to update the name property of the existing object:
                      return prevParents.map(parent => {
                        if (parent.id === row?.original?.parent_id) {
                          return {
                            ...parent,
                            name: row?.original?.full_name,
                          };
                        }
                        return parent;
                      });
                      // Alternatively, you can just return the existing state without any changes
                      // return prevParents;
                    }
                  });

                  setparentId(row?.original?.id);
                } else {
                  selectTab(row?.original?.id, row?.original);
                  handleCreateTabs([row?.original]);
                  // setOpenTabsList([row?.original]);
                  // window.location.href = '/home';
                }
              }}
            >
              {row.original.full_name}{' '}
            </span>
          </div>
        ),
        sortType: 'caseInsensitiveSort',
        disableSortBy: false,
      },
      {
        Header: 'Owner',
        accessor: 'owner',
        sticky: 'left',
        disableSortBy: true,
      },
      {
        Header: 'Created On',
        accessor: 'created_date',
        sticky: 'left',
        disableSortBy: false,
        Cell: ({ value }) => `${formatDate(value)}`,
      },
      {
        Header: 'Last Edited',
        accessor: 'last_updated',
        sticky: 'left',
        disableSortBy: false,
        Cell: ({ value }) => `${formatDate(value)}`,
      },
      {
        Header: 'Project Total',
        accessor: 'total',
        sticky: 'left',
        disableSortBy: false,
        Cell: ({ row }) =>
          row?.original?.type !== 'Folder'
            ? formatCurrency(row?.original.total || 0.0)
            : '--',
      },
      {
        Header: 'Collaborators',
        accessor: 'collaborators',
        sticky: 'left',
        disableSortBy: true,
        Cell: ({ row }) => {
          if (row?.original?.type === 'Folder') {
            return '--';
          }

          const collaboratorList = [...(row?.original?.collaborators || [])];

          // const editedByCollaborator = !collaboratorList
          //   ? false
          //   : collaboratorList?.every(
          //       collaborator => !collaborator.lastEdited
          //     );
          let editedByCollaborator = false;
          for (let i = 0; i < collaboratorList.length; i++) {
            if (collaboratorList[i]?.lastEdited) {
              editedByCollaborator = true;
              break;
            }
          }
          const dropdownLength = editedByCollaborator === false ? 3 : 4;
          collaboratorList.sort((a, b) => {
            return a.lastEdited === true ? -1 : 1;
          });
          const userDataTemp = [];
          if (editedByCollaborator === false) {
            userDataTemp?.push({
              id: row?.original?.id,
              name: row?.original?.created_by_name,
              email: row?.original?.created_by_email,
              profileImage: row?.original?.created_by_profile_image || '',
              lastEdited: row?.original?.last_edited_by,
              collaboratorsExists: row?.original?.collaborator,
            });
          }
          let visibleCollaborators = [];
          let dropdownCollaborators = [];
          const prevdata = userDataTemp;
          const tempdata =
            userDataTemp?.length > 0
              ? collaboratorList.slice(0, 3)
              : collaboratorList.slice(0, 4);
          visibleCollaborators = [...prevdata, ...tempdata];
          if (editedByCollaborator === true) {
            visibleCollaborators?.push({
              id: row?.original?.id,
              name: row?.original?.created_by_name,
              email: row?.original?.created_by_email,
              profileImage: row?.original?.created_by_profile_image || '',
              lastEdited: row?.original?.last_edited_by,
              collaboratorsExists: row?.original?.collaborator,
            });
          }
          if (visibleCollaborators?.length === 0) {
            visibleCollaborators?.push({
              id: row?.original?.id,
              name: row?.original?.created_by_name,
              email: row?.original?.created_by_email,
              profileImage: row?.original?.created_by_profile_image || '',
              lastEdited: row?.original?.last_edited_by,
              collaboratorsExists: row?.original?.collaborator,
            });
          }

          dropdownCollaborators =
            userDataTemp?.length > 0
              ? collaboratorList.slice(3)
              : collaboratorList.slice(4);
          return (
            <div className="collaborators-container">
              {visibleCollaborators?.map((collaborator, index) => (
                <div
                  key={getCollaboratorSeed(collaborator)}
                  className={handleCollaboratorCls(collaborator, index, row)}
                >
                  {collaborator?.profileImage ? (
                    <img
                      src={collaborator?.profileImage}
                      alt="Profile"
                      title={
                        collaborator?.name != null
                          ? `${collaborator?.name} (${collaborator?.email})`
                          : collaborator?.email
                      }
                      className="user-img"
                    />
                  ) : (
                    <span
                      className="user-initials"
                      style={{
                        backgroundColor:
                          getStableCollaboratorColor(collaborator),
                      }}
                      title={
                        collaborator?.name != null
                          ? `${collaborator?.name} (${collaborator?.email})`
                          : collaborator?.email
                      }
                    >
                      {getCollaboratorInitials(collaborator)}
                    </span>
                  )}
                </div>
              ))}

              {collaboratorList?.length > dropdownLength && (
                <div className="collaborators-dropdown">
                  <div className="dropdown-content">
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="success"
                        id="dropdown-basic"
                        className="dropdown-toggle-collaborators"
                      >
                        <ShowMore className="show-more" />
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        {dropdownCollaborators?.map(collaborator => {
                          const profileImage =
                            collaborator?.profileImage ||
                            collaborator?.collaborator_profile_image;
                          return (
                            <Dropdown.Item
                              key={getCollaboratorSeed(collaborator)}
                            >
                              <div className={'user-pic-wrapepr'}>
                                {profileImage ? (
                                  <img
                                    src={profileImage}
                                    alt="Profile"
                                    title={
                                      collaborator?.name != null
                                        ? `${collaborator?.name} (${collaborator?.email})`
                                        : collaborator?.email
                                    }
                                    className="user-img"
                                  />
                                ) : (
                                  <span
                                    className="user-initials"
                                    style={{
                                      backgroundColor:
                                        getStableCollaboratorColor(
                                          collaborator
                                        ),
                                    }}
                                    title={
                                      collaborator?.name != null
                                        ? `${collaborator?.name} (${collaborator?.email})`
                                        : collaborator?.email
                                    }
                                  >
                                    {getCollaboratorInitials(collaborator)}
                                  </span>
                                )}
                              </div>
                            </Dropdown.Item>
                          );
                        })}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              )}
            </div>
          );
        },
      },

      {
        Header: 'Actions',
        accessor: 'actions',
        sticky: 'left',
        disableSortBy: true,
        Cell: ({ row }) => (
          <div className="folder-actions-wrapper cursorpointer">
            <>
              {row?.original?.type === 'Folder' ? (
                <>
                  <Icon
                    name="FolderOpenIcon"
                    title="Move"
                    className="move-icon"
                    style={{ height: '20px', width: '20px', cursor: 'pointer' }}
                    onClick={() => {
                      setSelectedRows([row?.original]);
                      setShowMovePopup(true);
                    }}
                  />
                  <Edit
                    title="Edit"
                    style={{ height: '20px', width: '20px' }}
                    className="edit-icon-folder"
                    onClick={() => {
                      setShouldCallApi(false);
                      setShowEditFolder(true);
                      setFolderName(row?.original?.full_name);
                      setFolderId(row?.original?.id);
                      setparentId(row?.original?.id);
                    }}
                  />
                  <Delete
                    title="Delete"
                    onClick={() => setFolderSelectedDeldata(row?.original)}
                  />
                </>
              ) : (
                <>
                  <Icon
                    name="FolderOpenIcon"
                    title="Move"
                    className="move-icon"
                    style={{ height: '20px', width: '20px', cursor: 'pointer' }}
                    onClick={() => {
                      setSelectedRows([row?.original]);
                      setShowMovePopup(true);
                    }}
                  />
                  <Icon
                    name="ArrowUpFromBracketIcon"
                    title="Share"
                    style={{ height: '30px', width: '30px', cursor: 'pointer' }}
                    onClick={() =>
                      handleShare(row?.original?.id, row?.original)
                    }
                  />

                  {hasBudgetEditAccessInList(row?.original?.my_permission) && (
                    <Edit
                      title="Edit"
                      style={{ height: '20px', width: '20px' }}
                      onClick={() => {
                        setbudgetId(row?.original?.id);
                        setbudgetName(row?.original?.full_name);
                        // setparentId(row?.original?.id);
                        setShowEditBudgetFolder(true);
                        selectTab(row?.original?.id, row?.original);
                        setBudgetType(row?.original?.template_type);
                        // setBudgetToRename(row?.original);
                        // showCreateBudgetModal();
                      }}
                    />
                  )}

                  <DuplicateIcon
                    title="Duplicate"
                    style={{
                      height: '20px',
                      width: '20px',
                      cursor: 'pointer',
                    }}
                    onClick={() => handleDuplicateRow(row?.original)}
                  />

                  <Download
                    style={{ height: '40px', width: '40px' }}
                    title="Download"
                    onClick={() => {
                      window.location.href = `print-budget?id=${row?.original?.id}`;
                    }}
                  />

                  <Delete
                    title="Delete"
                    onClick={() => {
                      setSelectedDeldata([row?.original]);
                    }}
                  />
                </>
              )}
            </>
          </div>
        ),
      },
    ],
    [
      handleCreateTabs,
      handleDuplicateRow,
      handleShare,
      hasBudgetEditAccessInList,
      selectTab,
      selectedRows,
      setFolderSelectedDeldata,
      setSelectedDeldata,
    ]
  );

  // Custom sort function for case-insensitive string comparison
  const caseInsensitiveSort = (rowA, rowB, columnId, desc) => {
    const a = rowA.values[columnId]?.toString().toLowerCase();
    const b = rowB.values[columnId]?.toString().toLowerCase();

    if (a > b) return 1;
    if (a < b) return -1;
    return 0;
  };

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data,
        sortTypes: {
          caseInsensitiveSort,
        },
        initialState: { pageIndex: 0 },
        disableSortRemove: true,
      },
      useGlobalFilter,
      useSortBy,
      useRowSelect
    );

  return (
    <>
      <div className="budget-details-wrapper mt-3">
        <div className="details-header-wrapper">
          <div className="details-left d-flex align-items-center">
            <div className="detail-header">My Budgets</div>
            <div className="app-header-search" ref={searchBarRef}>
              <BudgetSearchInput
                onChange={handleSearchChange}
                onFocus={handleSearchChange}
                onKeyPress={handleKeyPress}
                handleClearSearch={handleClearSearch}
                searchVal={searchTxt}
              />
            </div>
            <div className="form-check">
              <input
                className="form-check-input adv-chk"
                type="checkbox"
                id="check1"
                name="option1"
                value="something"
                onChange={handleCheckboxChange}
              />
              <label className="form-check-label advanced-srch">
                Advanced Search
              </label>
            </div>
          </div>
          <div className="details-right d-flex align-items-center">
            <button
              label="New Folder"
              type="button"
              className="new-folder"
              // onClick={showCreateFolderModal}
              onClick={() => {
                setShowAddFolder(true);
              }}
            >
              <NewFolder />
              New Folder
            </button>
            <button
              label="New Budget"
              type="button"
              className="new-folder"
              onClick={() => setShowBudgetFolder(true)}
            >
              <NewBudget />
              New Budget
            </button>
          </div>
        </div>
        {loading ? (
          <CornerSpinner isLoading size="sm" label="Loading budgets" />
        ) : (
          <>
            {parentNames?.length > 0 && (
              <div className="folders-path">
                <div
                  className="bud-hed cursorpointer"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  My Budgets
                </div>
                <GreaterArrow />
                {/* <div className="arrow">&gt;</div> */}
                <>
                  {parentNames?.map((item, index) => (
                    <div className="folder-data" key={item}>
                      <FolderIcon />
                      <div
                        className="bud-head cursorpointer"
                        onClick={() => {
                          if (item?.parent_id === null) {
                            window?.location?.reload();
                          } else {
                            setparentId(item?.parent_id);
                            const indexOfParent15 = parentNames.findIndex(
                              parentData =>
                                parentData?.parent_id === item?.parent_id
                            );
                            const newArray =
                              indexOfParent15 !== -1
                                ? parentNames.slice(0, indexOfParent15 + 1)
                                : parentNames;
                            setparentNames(newArray);
                            setShouldCallApi(true);
                          }
                        }}
                      >
                        {item?.name}
                      </div>
                      {index < parentNames.length - 1 && <GreaterArrow />}
                    </div>
                  ))}
                </>
              </div>
            )}
            {selectedRows?.length > 1 && (
              <div className="selected-records-wrapper">
                <div className="sel-rec-item-count">
                  <CrossIcon onClick={() => setSelectedRows([])} />
                  {selectedRows?.length}{' '}
                  <>{selectedRows?.length === 1 ? 'item' : 'items'}</> selected
                </div>
                <div className="actions-wrapper">
                  <MoveIcon
                    title="Move"
                    className="move-icon"
                    onClick={() => {
                      setShowMovePopup(true);
                    }}
                  />
                  {selectedRows?.length <= 4 &&
                    selectedRows?.length > 0 &&
                    !selectedRows?.some(row => row?.type === 'Folder') && (
                      <OpenInNew
                        title="Open Tab"
                        onClick={() => {
                          selectTab(selectedRows[0]?.id, selectedRows[0]);
                          handleCreateTabs(selectedRows);
                        }}
                      />
                    )}
                  {selectedRows?.length === 1 &&
                    !selectedRows?.some(row => row?.type === 'Folder') && (
                      <Download
                        title="Download"
                        onClick={() => {
                          window.location.href = `print-budget?id=${selectedRows[0]?.id}`;
                        }}
                      />
                    )}
                  {selectedRows?.length > 0 &&
                    !selectedRows?.some(row => row?.type === 'Folder') && (
                      <DuplicateIcon
                        title="Duplicate"
                        onClick={handleDuplicateSelected}
                      />
                    )}
                  <Delete
                    title="Delete"
                    onClick={() => setSelectedDeldata(selectedRows)}
                  />
                </div>
              </div>
            )}
            <>
              <div className="admin-users-body">
                <>
                  <div
                    className={
                      selectedRows?.length > 1
                        ? 'table-container table-new-height mt-3'
                        : 'table-container mt-3'
                    }
                  >
                    <table {...getTableProps()} className="table-cls w-100">
                      <thead className="app-users-table-head">
                        {headerGroups?.map(headerGroup => (
                          <tr
                            {...headerGroup.getHeaderGroupProps()}
                            key={headerGroup}
                          >
                            {headerGroup.headers?.map(column => (
                              <th
                                {...column.getHeaderProps(
                                  column.getSortByToggleProps()
                                )}
                                key={column?.id}
                              >
                                {column.render('Header')}
                                <span>
                                  &nbsp;
                                  {column.disableSortBy === false ? (
                                    column?.isSorted ? (
                                      <span className="sorted-icon-highlight">
                                        {column.isSortedDesc ? (
                                          // Descending: Z-A for text, 9-1 for numbers
                                          column.id === 'total' ||
                                          column.id === 'created_date' ||
                                          column.id === 'last_updated' ? (
                                            <Icon
                                              name="ArrowUp91Icon"
                                              style={{
                                                width: '12px',
                                                height: '12px',
                                              }}
                                            />
                                          ) : (
                                            <Icon
                                              name="ArrowUpZAIcon"
                                              style={{
                                                width: '12px',
                                                height: '12px',
                                              }}
                                            />
                                          )
                                        ) : // Ascending: A-Z for text, 1-9 for numbers
                                        column.id === 'total' ||
                                          column.id === 'created_date' ||
                                          column.id === 'last_updated' ? (
                                          <Icon
                                            name="ArrowDown19Icon"
                                            style={{
                                              width: '12px',
                                              height: '12px',
                                            }}
                                          />
                                        ) : (
                                          <Icon
                                            name="ArrowDownAZIcon"
                                            style={{
                                              width: '12px',
                                              height: '12px',
                                            }}
                                          />
                                        )}
                                      </span>
                                    ) : (
                                      <Icon
                                        name="SortIcon"
                                        style={{
                                          width: '12px',
                                          height: '12px',
                                        }}
                                      />
                                    )
                                  ) : null}
                                </span>
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <>
                        {rows && products?.length > 0 ? (
                          <tbody
                            {...getTableBodyProps()}
                            className="table-scroll"
                          >
                            {rows && rows?.length > 0 && (
                              <>
                                {rows?.map(row => {
                                  prepareRow(row);
                                  const isSelected = selectedRows.some(
                                    selectedRow =>
                                      selectedRow.id === row.original.id &&
                                      selectedRow.type === row.original.type
                                  );
                                  const isFolderDropTarget =
                                    dragOverFolderId === row.original.id &&
                                    row.original.type === 'Folder';
                                  return (
                                    <tr
                                      {...row?.getRowProps()}
                                      className={`table-body-row ${
                                        isSelected ? 'selected-row' : ''
                                      } ${
                                        isFolderDropTarget
                                          ? 'folder-drop-target'
                                          : ''
                                      }`}
                                      draggable={
                                        row?.original?.type === 'Folder' ||
                                        row?.original?.type === 'Budget'
                                      }
                                      onDragStart={event =>
                                        handleRowDragStart(event, row.original)
                                      }
                                      onDragEnd={clearDragState}
                                      onDragOver={event =>
                                        handleRowDragOver(event, row.original)
                                      }
                                      onDragLeave={event =>
                                        handleRowDragLeave(event, row.original)
                                      }
                                      onDrop={event =>
                                        handleRowDrop(event, row.original)
                                      }
                                      key={row?.id}
                                    >
                                      <>
                                        {row?.cells?.map((cell, cellIndex) => {
                                          return (
                                            <td
                                              {...cell?.getCellProps()}
                                              key={cellIndex}
                                              style={{
                                                width:
                                                  cellIndex === 0
                                                    ? '40%'
                                                    : 'auto',
                                              }}
                                            >
                                              {cell.render('Cell')}
                                            </td>
                                          );
                                        })}
                                      </>
                                    </tr>
                                  );
                                })}
                              </>
                            )}
                          </tbody>
                        ) : (
                          <>
                            {searchQuery?.length > 0 ? (
                              <div className="no-budget-found">
                                <div className="no-found-head">
                                  {/* Lets Get Started! */}
                                </div>
                                <div className="no-found-res-body">
                                  No results found
                                </div>
                                {/* <button
                                    label="New Budget"
                                    type="button"
                                    className="new-folder"
                                    // onClick={showCreateBudgetModal}
                                    onClick={() => setShowBudgetFolder(true)}
                                  >
                                    New Budget
                                  </button> */}
                              </div>
                            ) : (
                              <div className="no-budget-found">
                                <div className="no-found-head">
                                  Lets Get Started!
                                </div>
                                <div className="no-found-body">
                                  {/* You don't have any existing budgets at the
                                  moment. How would you like to get started? */}
                                  Folder Empty "Create a New Budget in this
                                  Folder"
                                </div>
                                <button
                                  label="New Budget"
                                  type="button"
                                  className="new-folder"
                                  // onClick={showCreateBudgetModal}
                                  onClick={() => setShowBudgetFolder(true)}
                                >
                                  New Budget
                                </button>
                              </div>
                            )}
                          </>
                        )}
                      </>
                    </table>
                  </div>
                </>
              </div>
            </>
          </>
        )}
      </div>

      {showDeleteMultiBudgets && <DeleteMultiBudgets refetch={refetch} />}
      {showDeleteFolder && <DeleteFolder refetch={refetch} />}
      {showAddFolder && (
        <AddFolder
          parentid={parentId}
          showAddFolder={showAddFolder}
          closeFolder={closeFolder}
          refetch={refetch}
        />
      )}
      {showMovePopup && (
        <MoveBudgets
          showMovePopup={showMovePopup}
          onMoveClose={handleMovePopupClose}
          selBudgets={selectedRows}
          refetch={refetch}
        />
      )}
      {showEditFolder && (
        <EditFolder
          refetch={refetch}
          parentid={parentId}
          showEditFolder={showEditFolder}
          closeFolder={closeFolder}
          folderName={folderName}
          folderId={folderId}
        />
      )}

      {showBudgetFolder && (
        <CreateBudgetInsideFolder
          parentid={parentId}
          showBudgetFolder={showBudgetFolder}
          closeFolder={closeFolder}
          refetch={refetch}
        />
      )}
      {showEditBudgetFolder && (
        <EditBudgetInsideFolder
          budgetName={budgetName}
          parentid={parentId}
          budgetId={budgetId}
          showBudgetFolder={showEditBudgetFolder}
          id={parentId}
          BudgetTypeData={BudgetTypeData}
          closeFolder={closeFolder}
          refetch={refetch}
        />
      )}
    </>
  );
};
BudgetDetails.propTypes = {
  budgetList: PropTypes.array,
  row: PropTypes.shape({
    original: PropTypes.shape({
      type: PropTypes.string,
      id: PropTypes.number,
      full_name: PropTypes.string,
      // ... add other properties as needed
    }),
  }),
};
// BudgetDetails.defaultProps = {
//   budgetList: [],
// };
export default BudgetDetails;
